const { WebTransportCapabilities } = require('./web');

const TransportCapabilities = {
  web: WebTransportCapabilities,
};

module.exports.TransportCapabilities = TransportCapabilities;
